const SEO = [
	{
		page: "home",
		description:
			"Shivam Mehta - Full Stack Developer and Software Engineer. 60+ Projects delivered with 97% Client Satisfaction. Specializing in React, Node.js, and modern web technologies. Based in United States.",
		keywords: ["Shivam Mehta", "Full Stack Developer", "Software Engineer", "React", "Node.js", "Web Development", "United States"],
	},

	{
		page: "about",
		description:
			"Shivam Mehta is an engineering-driven developer with 5+ years of experience. Delivered 60+ successful projects helping clients increase revenue by 35% and reduce costs by 40%. Expert in full-stack development and modern web technologies.",
		keywords: ["Shivam Mehta", "Full Stack Developer", "Software Engineer", "5+ years experience", "60+ projects"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Shivam Mehta", "Programming", "Software Development", "Tech Articles"],
	},

	{
		page: "projects",
		description:
			"Featured projects by Shivam Mehta including E-Commerce platforms, Project Management SaaS, Mobile Applications, RESTful APIs, Analytics Dashboards, and AI-powered platforms. 60+ successful projects delivered.",
		keywords: ["Shivam Mehta", "Projects", "Portfolio", "E-Commerce", "SaaS", "Mobile Apps", "Full Stack"],
	},

	{
		page: "contact",
		description:
			"Contact Shivam Mehta for freelance projects, full-stack development, and consulting. Available on Upwork with 97% Job Success rate. Response time: 2 hours. 100% On-Time Delivery.",
		keywords: ["Shivam Mehta", "Contact", "Upwork", "Freelance", "Full Stack Developer", "Hire Developer"],
	},
];

export default SEO;
